export function adminLoginPath(pathname, search = "", hash = "") {
    const returnTo = `${pathname || "/"}${search || ""}${hash || ""}`;

    return `/admin?returnTo=${encodeURIComponent(returnTo)}`;
}

export function adminReturnPath(search) {
    const returnTo = new URLSearchParams(search).get("returnTo") || "";

    if (!returnTo.startsWith("/") || returnTo.startsWith("//")) {
        return "";
    }

    const parsedReturnTo = new URL(returnTo, "https://coach.local");
    const pathParts = parsedReturnTo.pathname.split("/").filter(Boolean);

    if (pathParts.length !== 2 || pathParts[1] !== "emails") {
        return "";
    }

    return `${parsedReturnTo.pathname}${parsedReturnTo.search}${parsedReturnTo.hash}`;
}
